import { render } from "./AdvertiserTopPerformersWidget.vue?vue&type=template&id=124a70c7"
import script from "./AdvertiserTopPerformersWidget.vue?vue&type=script&lang=js"
export * from "./AdvertiserTopPerformersWidget.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/production/releases/52/app.jumpfeed.com/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QSelect from 'quasar/src/components/select/QSelect.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QSelect});
